import React, { useMemo } from 'react';
import RendererActions from '../../actions/index';
export const RendererContext = /*#__PURE__*/React.createContext(new RendererActions());
export function RendererActionsContext({
  children,
  context
}) {
  const actions = useMemo(() => new RendererActions(true), []);
  return /*#__PURE__*/React.createElement(RendererContext.Provider, {
    value: context || actions
  }, React.Children.only(children));
}
export const RendererActionsContextConsumer = RendererContext.Consumer;